import { Reveal, Kicker } from "./motion";

const pillars = [
  {
    k: "Who built it",
    v: "People who have worked the pass and the floor, building the tool they always wished they had.",
  },
  {
    k: "Why it holds up",
    v: "One platform, one data model. What happens on the floor is exactly what you see in the numbers.",
  },
  {
    k: "What sets it apart",
    v: "Nothing bolted on, nothing to reconcile. Hospitality first, from the very first line of code.",
  },
];

export default function BuiltAround() {
  return (
    <section
      data-testid="built-around"
      className="px-6 md:px-12 py-28 md:py-40 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Kicker>Built around restaurants</Kicker>
          <h2 className="mt-8 font-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.1] text-verlo max-w-4xl text-balance">
            Not adapted from retail. Not borrowed from another till. Designed for
            hospitality, from day one.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-10 md:gap-16">
          {pillars.map((p) => (
            <Reveal key={p.k}>
              <p className="text-xs tracking-[0.2em] uppercase text-brass mb-4">{p.k}</p>
              <p className="text-lg md:text-xl leading-relaxed text-verlo">{p.v}</p>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 md:mt-28 relative h-[55vh] md:h-[70vh] overflow-hidden rounded-lg shadow-soft">
            <img
              src="https://images.pexels.com/photos/6816368/pexels-photo-6816368.jpeg"
              alt="Front of house staff during a warm service"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
